import { render, staticRenderFns } from "./PlayerControlsButtonPlay.vue?vue&type=template&id=297f602e&scoped=true&"
import script from "./PlayerControlsButtonPlay.vue?vue&type=script&lang=js&"
export * from "./PlayerControlsButtonPlay.vue?vue&type=script&lang=js&"
import style0 from "./PlayerControlsButtonPlay.vue?vue&type=style&index=0&id=297f602e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297f602e",
  null
  
)

export default component.exports